import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { NatConfiguration } from 'data/natConfiguration/natConfiguration.types';

export enum NatConfigurationActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newNatConfiguration: NatConfiguration = {
  privateIp: '',
  privatePort: '',
  publicIp: '',
  publicPort: '',
};

export const distributorColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('natConfiguration.grid.privatePort'),
    field: 'PRIVATEPORT',
    sortable: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    tooltipField: 'Private Port',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('natConfiguration.grid.privateIp'),
    field: 'PRIVATEIP',
    sortable: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    tooltipField: 'Private IP Address',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('natConfiguration.grid.publicPort'),
    field: 'PUBLICPORT',
    sortable: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    tooltipField: 'Public Port',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('natConfiguration.grid.publicIp'),
    field: 'PUBLICIP',
    sortable: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    tooltipField: 'Public IP Address',
    flex: 1,
    minWidth: 198,
  },
];
